import { LOGO_BODY_PATH } from "@rakazo/core";
import { memo } from "react";

/** Fully vector D body. It is filled with the theme foreground via CSS. */
export const LogoAvatarBody = memo(function LogoAvatarBody() {
  return (
    <g className="logo-avatar-art">
      <path className="logo-avatar-d" d={LOGO_BODY_PATH} />
    </g>
  );
});
